module.exports = __webpack_public_path__ + "wxMicroService/img/bus.03b1417e.png";